import map from 'mn-utils/map';

const USER_ROLES_IDS = [
  'admin',
  'merchant',
  'mpos_user',
  'merchant_user',
];

const USER_ROLES_NAMES = {
  admin: 'Admin',
  merchant: 'Merchant',
  mpos_user: 'Terminal',
  merchant_user: 'Merchant\'s user',
};

module.exports = {
  userRolesFilter: {
    name: 'account_type',
    placeholder: 'User role',
    className: 'w190',
    list: map(USER_ROLES_IDS, (id) => ({
      id,
      name: USER_ROLES_NAMES[id],
    })),
  },
  userRolesNames: USER_ROLES_NAMES,
};
